export default __webpack_public_path__ + "static/media/payment-svg.5de499a1.svg";